import {
  injectable,
  IModuleLifecycleContribution,
  inject,
  IAbilitiesService,
} from '@meego-remote/core/app/contract';
import { ABILITIES } from '@meego-remote/main/platform/private/secondNavCollaboration';
import { BasicAbilities } from '@meego-remote/platform/basic/contract';
import { isVisitorEnvironment, VISITOR_ABILITIES } from './utils';

@injectable({ implements: [IModuleLifecycleContribution] })
export class VisitorModuleLifecycleContribution extends IModuleLifecycleContribution {
  @inject(IAbilitiesService)
  protected readonly abilitiesService!: IAbilitiesService;

  override onInit() {
    // Check if in visitor environment
    if (!isVisitorEnvironment()) {
      return;
    }
    this.setupAbilities();
  }

  private setupAbilities(): void {
    this.abilitiesService.getOrCreate(BasicAbilities);
    this.abilitiesService.set(BasicAbilities, VISITOR_ABILITIES as InstanceType<typeof BasicAbilities>, {
      merge: true,
    });
    const updatedBasicAbilities = this.abilitiesService.getOrCreate(BasicAbilities);
    Object.assign(ABILITIES, updatedBasicAbilities);
  }
}
